<template>
  <div>
    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>
<script>
import { HTTP } from "@/utils/http";
import store from "@/store/index.js";
import Apis from "@/apis/index";
import Enums from "@/apis/_enums";
import {mapState} from "vuex";
export default {
  name: "DayTemplateDetailsMaster",
  mounted() {
    this.stationUid = this.$route.params.stationUid;
    this.clockUid = this.$route.params.clockUid;
    this.loadDt();
  },
  computed: {
    ...mapState({
      isConstraintModified: state => state.isConstraintModified
    })
  },
  beforeRouteUpdate(to, from, next) {
    if (!!this.isConstraintModified) {
      const message = confirm("Are you sure you want to exit ? Some changes aren\'t saved")
      if (message) {
        this.$store.commit('setStatusConstraint', false)
        next()
      }
    } else {
      next()
    }
  },
  watch: {
    $route: function(to, from) {
      this.stationUid = this.$route.params.stationUid;
      this.boxClockUid = this.$route.params.clockUid;
      this.loadDt();
    }
  },
  methods: {
    loadDt: function() {
      if (
        this.$route.params != null &&
        this.$route.params.stationUid != null &&
        this.$route.params.dayTemplateUid != null
      ) {
        store.dispatch("loadDayTemplate", this.$route.params);
      }
    }
  }
};
</script>
